import type { Infer } from 'superstruct';
import { assign, object, optional, partial, string } from 'superstruct';

import { ViewFacebookAdSetBudgetTemplateDto } from '@adflow/shared/data-facebook-ads';

export const HistoryFacebookAdSetBudgetTemplateDto = assign(
	partial(ViewFacebookAdSetBudgetTemplateDto),
	partial(
		object({
			// Include avbId for budget identification
			avbId: optional(string()),
		})
	)
);

export type HistoryFacebookAdSetBudgetTemplateDto = Infer<
	typeof HistoryFacebookAdSetBudgetTemplateDto
>;
